/* Cacheable pre-init owner for the sticky product bar and optional desktop mega hover. */
(function(){
  'use strict';
  var owner = document.currentScript;
  var megaMenuEnabled = !!(owner && owner.getAttribute('data-mega-menu') === 'true');
(function(){
  function boot(){
    var bar=document.getElementById('sjw-sticky');
    if(!bar||bar.__sjwReveal)return; bar.__sjwReveal=1;
    function headerBottom(){
      var h=document.querySelector('.header-section, [data-header-sticky], header');
      if(h){ var r=h.getBoundingClientRect(); return Math.max(0, Math.round(r.bottom)); }
      return 0;
    }
    var anchor=document.querySelector('.product-media, .js-product-media-container, .product-media__slider, .product-gallery, .product__media');
    var ticking=false;
    function ev(){
      var top=headerBottom();
      bar.style.top=top+'px';
      var show;
      if(anchor){ show = anchor.getBoundingClientRect().bottom < top+8; }
      else { show = window.scrollY > 360; }
      if(show){ bar.classList.add('is-visible'); bar.setAttribute('aria-hidden','false'); }
      else { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden','true'); }
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){ ev(); ticking=false; }); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    ev();
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
})();
  if (megaMenuEnabled) {
  (function(){
    function bind(){
      var tops=document.querySelectorAll('.header-menu__list--main > .header-menu__item-wrapper');
      if(!tops.length)return;
      [].forEach.call(tops,function(top){
        if(top.__sjwHover)return;
        var wrap=top.querySelector('.header-menu__list-nested-wrapper');
        var tog=wrap?wrap.previousElementSibling:null;
        if(!wrap||!tog)return;
        top.__sjwHover=1;
        var ct;
        top.addEventListener('mouseenter',function(){clearTimeout(ct);[].forEach.call(document.querySelectorAll('.header-menu__list--main .header-menu__item.is-active'),function(a){a.classList.remove('is-active');});tog.classList.add('is-active');});
        top.addEventListener('mouseleave',function(){ct=setTimeout(function(){tog.classList.remove('is-active');},250);});
      });
    }
    if(document.readyState!=='loading')bind();else document.addEventListener('DOMContentLoaded',bind);
    setTimeout(bind,800);setTimeout(bind,1700);
  })();
  }
})();
